export const DIALOG_IDS = {
  OBJECT_PICKER_DIALOG: "object-picker-dialog",
} as const;

export type DialogId = (typeof DIALOG_IDS)[keyof typeof DIALOG_IDS];
